import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AccesRefuse() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="page-acces-refuse">
      <div className="w-14 h-14 rounded-full bg-[#FEE2E2] flex items-center justify-center mb-4">
        <ShieldAlert className="w-7 h-7 text-[#B91C1C]" />
      </div>
      <h1 className="text-xl font-bold">Accès non autorisé</h1>
      <p className="text-[13.5px] text-[--idc-muted] mt-2 max-w-sm">
        Votre rôle ne vous donne pas accès à ce module. Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.
      </p>
      <Link to="/"><Button variant="outline" className="mt-5" data-testid="acces-refuse-retour-btn">Retour au tableau de bord</Button></Link>
    </div>
  );
}
